<template>
  <div class="tab-container">
    <!-- 横向可滚动的标签栏 -->
    <div class="tab-scroll-wrapper" ref="headertab">
      <div class="tab-header">
        <div
          :style="{
            fontSize: datas.textSize + 'px',
          }"
          v-for="(item, index) in datas.tagList"
          :key="index"
          :class="['tab-item', { active: datas.activeIndex === index }]"
          @click="handleTabClick(item, index)"
          ref="tabItem"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <!-- 内容区域 -->
    <div class="tab-content">
      <section style="margin-top: 10px">
        <div
          v-if="datas.activeIndex == 0"
          style="margin: 20px auto; width: 100%; text-align: center"
        >
          <p style="margin-bottom: 50px">
            请点击按钮添加模块{{ datas.activeIndex }}
          </p>
          <div
            class="flex"
            style="
              text-align: center;
              margin-top: 50px;
              justify-content: center;
            "
          >
            <div v-for="item in actionButtons.moduleButtons" :key="item.id">
              <CustomButton
                v-if="item.type === 'addModule'"
                style="margin-left: 20px"
                :text="item.text"
                type="primary"
                size="small"
                @click="handleClick(item)"
              />
            </div>
          </div>
        </div>
        <div v-else>
          这里是内容区域 {{ datas.tagList[datas.activeIndex].comType }}
        </div>
      </section>
      <!-- <slot :activeKey="activeKey"></slot> -->
    </div>
    <CustomDialog
      title="添加模块"
      :visible.sync="dialogVisible"
      :showFooter="false"
      width="50%"
    >
      <!-- 自定义弹窗内容 -->
      <template #content>
        <div class="custom-content">
          <AddModule :datas="datas" @handleClick="handleAddModuleClick" />
        </div>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
// 引入相关静态数据配置
import { actionButtons } from "@/utils/defaultData";
import componentProperties from "@/utils/componentProperties"; // 组件数据
export default {
  name: "transversustag",
  props: {
    datas: Object,
  },
  data() {
    return {
      dialogVisible: false,
      pageComponents: Array.from(componentProperties.values()),
      currentComponent: {},
    };
  },
  methods: {
    // 按钮点击处理方法
    handleClick(button, row) {
      // 可以在这里添加按钮点击逻辑
      if (button.handler) {
        this[button.handler](button, row);
      }
    },
    handleClick(button, row) {
      console.log("点击了按钮", button);
      this.dialogVisible = true;
    },
    // 处理标签点击
    handleTabClick(item, index) {
      if (index == this.datas.activeIndex) return;
      this.datas.activeIndex = index;
      // 执行滚动逻辑
      this.scrollToActiveTab(index);
      console.log("切换标签", this.datas, item, index);
    },
    // 核心：滚动到激活的tab项
    scrollToActiveTab(index) {
      // ===== 横向自动滚动逻辑 =====
      this.$nextTick(() => {
        const tab = this.$refs.headertab;
        const li = this.$refs.tabItem[index];
        if (!li || !tab) return;

        const liLeft = li.offsetLeft;
        const liRight = liLeft + li.offsetWidth;
        const clientWidth = tab.clientWidth;
        const SAFE = 90;
        /* 1. 先算出「应该滚动到哪里」 */
        let target = tab.scrollLeft; // 默认保持原位
        if (liRight > tab.scrollLeft + clientWidth - SAFE) {
          target = liRight - clientWidth + SAFE;
        } else if (liLeft < tab.scrollLeft + SAFE) {
          target = Math.max(0, liLeft - SAFE);
        }
        /* 2. 和目标不一致才真正滚动 */
        if (Math.abs(target - tab.scrollLeft) > 1) {
          tab.scrollTo({ left: target, behavior: "smooth" });
        }
      });
    },
    // 处理添加模块点击事件
    handleAddModuleClick(event) {
      const currentComponent = this.pageComponents.find(
        (item) => item.component == event.item.name,
      );
      const obj = {
        name: currentComponent.setStyle.text,
        comType: currentComponent.component,
        comList: [currentComponent],
      };
      
      // 判断tagLiat的第一个和第二个是否是原始数组内容
      if (this.datas.tagList[0].type && this.datas.tagList[1].type) {
        this.datas.tagList.splice(1, 1);
      }
      this.datas.tagList.push(obj);
      const currentTagIndex = this.datas.tagList.findIndex(
        (item) => item.comType == currentComponent.component,
      );
      console.log(
        "添加模块父组件回调handleAddModuleClick方法",
        event,
        this.datas,
        currentComponent,
        currentTagIndex,
      ); 
      this.datas.activeIndex = currentTagIndex;
      this.dialogVisible = false;
      return;

      this.$store.commit("modules/CLEAR_CURRENT_COMPONENT");
      this.$store.commit("modules/SET_CURRENT_COMPONENT", currentComponent);
      this.currentComponent = currentComponent;

      console.log(
        "处理模块点击事件",
        event,
        this.pageComponents,
        currentComponent,
      );

      // 赋值当前添加的当前模块所在下标位置
      this.datas.activeIndex = currentTagIndex; //用与判断显示对应激活导航下的组件
      console.log("走到这里了", this.datas, this.datas.activeIndex);
      // 可以在这里添加添加模块的逻辑
      // 例如，将选中的模块添加到当前活动标签页的组件列表中
      // this.datas.tabs[this.active].comList.push(data.item);
      // // 关闭弹窗
      //
    },
  },
};
</script>

<style scoped>
/* 容器样式 */
.tab-container {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  padding: 10px;
}

/* 横向滚动容器 - 核心滚动样式 */
.tab-scroll-wrapper {
  width: 100%;
  overflow-x: auto; /* 横向滚动 */
  overflow-y: hidden;
  /* 隐藏滚动条（兼容主流浏览器） */
  -ms-overflow-style: none;
  scrollbar-width: none;
}
/* 隐藏 Chrome/Edge 滚动条 */
.tab-scroll-wrapper::-webkit-scrollbar {
  display: none;
}

/* 标签栏 */
.tab-header {
  display: flex;
  background-color: #f9fafb;
  white-space: nowrap; /* 标签不换行 */
  padding: 0 8px;
}

/* 标签项样式 */
.tab-item {
  padding: 8px 10px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  position: relative; /* 用于定位下划线 */
  transition: color 0.2s;
  white-space: nowrap;
}

/* 标签 hover 效果 */
.tab-item:hover {
  color: #165dff;
}

/* 激活标签样式 */
.tab-item.active {
  color: #165dff;
  font-weight: 500;
}

/* 激活标签的底部下划线 - 核心样式 */
.tab-item.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 25px; /* 下划线宽度 */
  height: 3px; /* 下划线高度 */
  background-color: #165dff;
  border-radius: 5px;
}

/* 内容区域 */
.tab-content {
  /* padding: 20px; */
}
</style>
